import { useQuery } from '@tanstack/react-query'

import { ButterflyAccessPoint } from '@/api/keyless/butterfly/get-butterfly-access-points'
import { authAPI } from '@/api/new-api'

type GetButterflyConnectionRequest = {
  buildingId: number
}

export type ButterflyConnection = {
  shouldAutoAssignApartmentDoorVisitor: boolean
  visitorPermissionDoors: ButterflyAccessPoint[]
}

export const getButterflyConnectionQueryKey = (data: GetButterflyConnectionRequest) => [
  'useGetButterflyConnection',
  data,
]

const getButterflyConnection = async (data: GetButterflyConnectionRequest) => {
  const response = await authAPI.get<ButterflyConnection>(
    `/butterfly/integration/${data.buildingId}`,
  )
  return response.data
}

export const useGetButterflyConnection = (data: GetButterflyConnectionRequest) =>
  useQuery({
    enabled: Boolean(data.buildingId),
    queryFn: () => getButterflyConnection(data),
    queryKey: getButterflyConnectionQueryKey(data),
  })
